<template>
  <Modal :value="value" @input="(v) => $emit('input', v)" :width="760" footer-hide class="notice-dialog">
    <!-- 顶部喇叭横幅(近似原站插画) -->
    <div class="nd-banner">
      <Icon type="md-megaphone" class="nd-mega" />
      <span class="nd-en">Platform Announcement</span>
    </div>
    <div class="nd-body">
      <!-- 左:公告列表 -->
      <div class="nd-list">
        <div v-for="(n, i) in list" :key="i" class="nd-item" :class="{ on: i === active }" @click="active = i">
          <Icon v-if="n.icon" type="md-megaphone" class="nd-item-ic" />{{ n.tag }}
        </div>
      </div>
      <!-- 右:选中公告内容 -->
      <div class="nd-content">
        <div class="nd-scroll">
          <div class="nd-date">{{ cur.date }}</div>
          <p v-for="(p, i) in cur.paras" :key="i" class="nd-para" :class="p.type">
            <Icon v-if="p.type === 'path'" type="ios-lock-outline" class="nd-inline-ic" />
            <Icon v-if="p.type === 'step'" type="md-list-box" class="nd-inline-ic" />{{ p.text }}
          </p>
        </div>
        <div class="nd-page">{{ active + 1 }} / {{ list.length }}</div>
      </div>
    </div>
  </Modal>
</template>

<script>
// 顶部"更多>>"公告弹窗(对齐截图:左公告列表 + 右内容 + 分页)
export default {
  name: 'NoticeDialog',
  props: { value: { type: Boolean, default: false } },
  data() {
    return {
      active: 0,
      list: [
        {
          tag: '安全通知', icon: false, date: '2025-12-22 20:36:14',
          paras: [
            { type: 'title', text: '尊敬的群主您好:' },
            { type: '', text: '为进一步加强账号安全,防范因账号被盗导致的管理风险,平台建议所有群主尽快开启二次验证(2FA)功能,以提升账号整体安全等级。' },
            { type: '', text: '二次验证开启后,即使账号密码泄露,仍需通过动态验证码验证,能有效防止他人非法登录。' },
            { type: 'path', text: '二次验证开启路径' },
            { type: '', text: '群主后台 → 右上角头像 → 开启二次验证' },
            { type: 'step', text: '操作步骤说明' }
          ]
        },
        {
          tag: '系统公告', icon: true, date: '2025-12-20 10:00:00',
          paras: [
            { type: 'title', text: '系统维护通知' },
            { type: '', text: '为提供更稳定的服务,平台将于每日凌晨进行例行维护,维护期间部分功能可能短暂不可用,给您带来不便敬请谅解。' }
          ]
        },
        {
          tag: '系统公告', icon: true, date: '2025-12-18 09:00:00',
          paras: [
            { type: 'title', text: '功能更新公告' },
            { type: '', text: '本次更新优化了开奖推送与账单展示性能,并修复了若干已知问题。感谢您的使用与支持。' }
          ]
        }
      ]
    }
  },
  computed: {
    cur() { return this.list[this.active] }
  }
}
</script>

<style lang="less" scoped>
@import '../../styles/tokens.less';
.notice-dialog :deep(.ivu-modal-body) { padding: 0; }
.notice-dialog :deep(.ivu-modal-content) { border-radius: 8px; overflow: hidden; }
// 横幅
.nd-banner {
  height: 130px; background: linear-gradient(120deg, #cfe6ff 0%, #a9d1ff 55%, #cfe6ff 100%);
  display: flex; align-items: center; justify-content: center; gap: 12px; position: relative;
}
.nd-mega { font-size: 56px; color: #2f6fd0; transform: rotate(-12deg); }
.nd-en { font-size: 30px; font-weight: 700; color: #fff; opacity: .55; letter-spacing: 1px; }
// 两栏
.nd-body { display: flex; height: 320px; }
.nd-list { width: 150px; flex-shrink: 0; padding: 18px 12px; display: flex; flex-direction: column; gap: 12px; border-right: 1px solid @border-light; }
.nd-item {
  display: flex; align-items: center; gap: 4px; justify-content: center;
  padding: 8px 6px; border-radius: 4px; cursor: pointer; font-size: 13px;
  color: @text-sub; background: @row-alt;
}
.nd-item.on { background: @primary; color: #fff; }
.nd-item-ic { font-size: 15px; }
// 内容
.nd-content { flex: 1; min-width: 0; padding: 16px 18px; display: flex; flex-direction: column; }
.nd-scroll { flex: 1; overflow-y: auto; }
.nd-date { color: @text-muted; font-size: 12px; margin-bottom: 10px; }
.nd-para { font-size: 13px; line-height: 1.7; color: @text-main; margin: 0 0 8px; }
.nd-para.title { font-weight: 600; }
.nd-para.path, .nd-para.step { color: @primary; display: flex; align-items: center; gap: 4px; }
.nd-inline-ic { font-size: 15px; }
.nd-page { text-align: center; color: @text-muted; font-size: 13px; padding-top: 8px; }
</style>
